module.exports = __webpack_public_path__ + "74bf6d111fe975e358ca896a69a833f2.png";